var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "form",
    {
      staticClass: "applicant-form",
      on: {
        submit: function ($event) {
          $event.preventDefault()
        },
      },
    },
    [
      _c("div", { staticClass: "field" }, [
        _c("div", { staticClass: "field-header" }, [
          _c(
            "label",
            {
              staticClass: "field-label",
              attrs: { for: "contest-entry-name" },
            },
            [
              _vm._v(
                " " +
                  _vm._s(_setup.t("contestEntryForm.step1.name.label")) +
                  " "
              ),
              _c(
                "span",
                {
                  staticClass: "required-mark",
                  attrs: { "aria-hidden": "true" },
                },
                [_vm._v("*")]
              ),
            ]
          ),
          _c("span", { staticClass: "field-count" }, [
            _vm._v(_vm._s(_vm.value.name.length) + "/100"),
          ]),
        ]),
        _c("input", {
          staticClass: "field-input",
          attrs: {
            id: "contest-entry-name",
            type: "text",
            maxlength: "100",
            placeholder: _setup.t("contestEntryForm.step1.name.placeholder"),
          },
          domProps: { value: _vm.value.name },
          on: { input: _setup.handlers.onNameInput },
        }),
      ]),
      _c("div", { staticClass: "field" }, [
        _c("div", { staticClass: "field-header" }, [
          _c(
            "label",
            {
              staticClass: "field-label",
              attrs: { for: "contest-entry-name-kana" },
            },
            [
              _vm._v(
                " " +
                  _vm._s(_setup.t("contestEntryForm.step1.nameKana.label")) +
                  " "
              ),
              _c(
                "span",
                {
                  staticClass: "required-mark",
                  attrs: { "aria-hidden": "true" },
                },
                [_vm._v("*")]
              ),
            ]
          ),
          _c("span", { staticClass: "field-count" }, [
            _vm._v(_vm._s(_vm.value.nameKana.length) + "/100"),
          ]),
        ]),
        _c("input", {
          staticClass: "field-input",
          attrs: {
            id: "contest-entry-name-kana",
            type: "text",
            maxlength: "100",
            placeholder: _setup.t(
              "contestEntryForm.step1.nameKana.placeholder"
            ),
          },
          domProps: { value: _vm.value.nameKana },
          on: { input: _setup.handlers.onNameKanaInput },
        }),
      ]),
      _c("div", { staticClass: "field" }, [
        _c(
          "label",
          {
            staticClass: "field-label",
            attrs: { for: "contest-entry-penname" },
          },
          [
            _vm._v(
              " " +
                _vm._s(_setup.t("contestEntryForm.step1.penname.label")) +
                " "
            ),
            _c(
              "span",
              {
                staticClass: "required-mark",
                attrs: { "aria-hidden": "true" },
              },
              [_vm._v("*")]
            ),
          ]
        ),
        _c(
          "div",
          {
            ref: "pennameFieldRef",
            staticClass: "select-wrapper",
            class: { "is-open": _setup.isPennameMenuOpen },
          },
          [
            _c(
              "div",
              { staticClass: "penname-control" },
              [
                _c(
                  "button",
                  {
                    staticClass: "field-input field-select penname-trigger",
                    attrs: {
                      id: "contest-entry-penname",
                      type: "button",
                      "aria-expanded": _setup.isPennameMenuOpen,
                      "aria-haspopup": "listbox",
                      "aria-controls": "contest-entry-penname-list",
                    },
                    on: { click: _setup.togglePennameMenu },
                  },
                  [
                    _c("span", { staticClass: "penname-trigger-text" }, [
                      _vm._v(_vm._s(_vm.value.penname)),
                    ]),
                  ]
                ),
                _c(_setup.IconChevronDown, { staticClass: "select-chevron" }),
              ],
              1
            ),
            _setup.isPennameMenuOpen
              ? _c(
                  "div",
                  {
                    staticClass: "penname-menu",
                    attrs: { id: "contest-entry-penname-list" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "penname-options",
                        attrs: {
                          role: "listbox",
                          "aria-label": _setup.t(
                            "contestEntryForm.step1.penname.label"
                          ),
                        },
                      },
                      _vm._l(_vm.pennameOptions, function (name) {
                        return _c(
                          "button",
                          {
                            key: name,
                            staticClass: "penname-option",
                            attrs: {
                              type: "button",
                              role: "option",
                              "aria-selected": _vm.value.penname === name,
                            },
                            on: {
                              click: function ($event) {
                                return _setup.onSelectPenname(name)
                              },
                            },
                          },
                          [
                            _vm.value.penname === name
                              ? _c(_setup.IconCheck, {
                                  staticClass:
                                    "penname-option-icon penname-option-check",
                                  attrs: { "aria-hidden": "true" },
                                })
                              : _c("span", {
                                  staticClass: "penname-option-spacer",
                                  attrs: { "aria-hidden": "true" },
                                }),
                            _c(
                              "span",
                              { staticClass: "penname-option-label" },
                              [_vm._v(_vm._s(name))]
                            ),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "penname-option",
                        attrs: { type: "button" },
                        on: { click: _setup.openAddPennameDialog },
                      },
                      [
                        _c(_setup.IconPlus, {
                          staticClass: "penname-option-icon",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _c("span", { staticClass: "penname-option-label" }, [
                          _vm._v(
                            _vm._s(
                              _setup.t("contestEntryForm.step1.penname.add")
                            )
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
          ]
        ),
      ]),
      _c("div", { staticClass: "field" }, [
        _c("div", { staticClass: "field-header" }, [
          _c(
            "label",
            {
              staticClass: "field-label",
              attrs: { for: "contest-entry-email" },
            },
            [
              _vm._v(
                " " +
                  _vm._s(_setup.t("contestEntryForm.step1.email.label")) +
                  " "
              ),
              _c(
                "span",
                {
                  staticClass: "required-mark",
                  attrs: { "aria-hidden": "true" },
                },
                [_vm._v("*")]
              ),
            ]
          ),
          _c("span", { staticClass: "field-count" }, [
            _vm._v(_vm._s(_vm.value.email.length) + "/100"),
          ]),
        ]),
        _c("input", {
          staticClass: "field-input",
          attrs: {
            id: "contest-entry-email",
            type: "email",
            maxlength: "100",
            placeholder: _setup.t("contestEntryForm.step1.email.placeholder"),
          },
          domProps: { value: _vm.value.email },
          on: { input: _setup.handlers.onEmailInput },
        }),
      ]),
      _c("div", { staticClass: "field" }, [
        _c("div", { staticClass: "field-header" }, [
          _c(
            "label",
            {
              staticClass: "field-label",
              attrs: { for: "contest-entry-phone" },
            },
            [
              _vm._v(
                " " +
                  _vm._s(_setup.t("contestEntryForm.step1.phone.label")) +
                  " "
              ),
              _c(
                "span",
                {
                  staticClass: "required-mark",
                  attrs: { "aria-hidden": "true" },
                },
                [_vm._v("*")]
              ),
            ]
          ),
          _c("span", { staticClass: "field-count" }, [
            _vm._v(_vm._s(_vm.value.phone.length) + "/100"),
          ]),
        ]),
        _c("input", {
          staticClass: "field-input",
          attrs: {
            id: "contest-entry-phone",
            type: "tel",
            maxlength: "100",
            placeholder: _setup.t("contestEntryForm.step1.phone.placeholder"),
          },
          domProps: { value: _vm.value.phone },
          on: { input: _setup.handlers.onPhoneInput },
        }),
      ]),
      _c("div", { staticClass: "field" }, [
        _c(
          "label",
          {
            staticClass: "field-label",
            attrs: { for: "contest-entry-gender" },
          },
          [_vm._v(_vm._s(_setup.t("contestEntryForm.step1.gender.label")))]
        ),
        _c(
          "div",
          { staticClass: "select-wrapper" },
          [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _setup.genderSelectValue,
                    expression: "genderSelectValue",
                  },
                ],
                staticClass: "field-input field-select",
                attrs: { id: "contest-entry-gender" },
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _setup.genderSelectValue = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                },
              },
              [
                _c("option", { attrs: { value: "" } }, [
                  _vm._v(_vm._s(_setup.t("common.unselected"))),
                ]),
                _vm._l(_setup.genderOptions, function (option) {
                  return _c(
                    "option",
                    { key: option.value, domProps: { value: option.value } },
                    [_vm._v(" " + _vm._s(option.label) + " ")]
                  )
                }),
              ],
              2
            ),
            _c(_setup.IconChevronDown, { staticClass: "select-chevron" }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "field" }, [
        _c(
          "label",
          {
            staticClass: "field-label",
            attrs: { for: "contest-entry-birthdate" },
          },
          [
            _vm._v(
              " " +
                _vm._s(_setup.t("contestEntryForm.step1.birthDate.label")) +
                " "
            ),
            _c(
              "span",
              {
                staticClass: "required-mark",
                attrs: { "aria-hidden": "true" },
              },
              [_vm._v("*")]
            ),
          ]
        ),
        _c("input", {
          staticClass: "field-input",
          attrs: {
            id: "contest-entry-birthdate",
            type: "date",
            placeholder: _setup.t(
              "contestEntryForm.step1.birthDate.placeholder"
            ),
          },
          domProps: { value: _vm.value.birthDate },
          on: { input: _setup.handlers.onBirthDateInput },
        }),
      ]),
      _c("div", { staticClass: "field" }, [
        _c("div", { staticClass: "field-header" }, [
          _c(
            "label",
            {
              staticClass: "field-label",
              attrs: { for: "contest-entry-history-of-awards" },
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _setup.t("contestEntryForm.step1.historyOfAwards.label")
                  ) +
                  " "
              ),
            ]
          ),
          _c("span", { staticClass: "field-count" }, [
            _vm._v(
              _vm._s(_vm.value.historyOfAwards.length) +
                "/" +
                _vm._s(_setup.historyOfAwardsMaxLength)
            ),
          ]),
        ]),
        _c("textarea", {
          staticClass: "field-input field-textarea",
          attrs: {
            id: "contest-entry-history-of-awards",
            maxlength: _setup.historyOfAwardsMaxLength,
            rows: "5",
            placeholder: _setup.t(
              "contestEntryForm.step1.historyOfAwards.placeholder"
            ),
          },
          domProps: { value: _vm.value.historyOfAwards },
          on: { input: _setup.handlers.onHistoryOfAwardsInput },
        }),
      ]),
      _setup.isAddPennameOpen
        ? _c(
            "div",
            {
              staticClass: "penname-dialog-mask",
              on: {
                click: function ($event) {
                  if ($event.target !== $event.currentTarget) return null
                  return _setup.closeAddPennameDialog.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "penname-dialog",
                  attrs: {
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-labelledby": "contest-entry-penname-dialog-title",
                  },
                },
                [
                  _c("header", { staticClass: "penname-dialog-header" }, [
                    _c(
                      "h2",
                      {
                        staticClass: "penname-dialog-title",
                        attrs: { id: "contest-entry-penname-dialog-title" },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _setup.t(
                                "contestEntryForm.step1.penname.dialogTitle"
                              )
                            ) +
                            " "
                        ),
                      ]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "penname-dialog-close",
                        attrs: {
                          type: "button",
                          "aria-label": _setup.t("common.close"),
                        },
                        on: { click: _setup.closeAddPennameDialog },
                      },
                      [
                        _c(_setup.IconClose, {
                          staticClass: "penname-dialog-close-icon",
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "penname-dialog-body" }, [
                    _c("div", { staticClass: "field-header" }, [
                      _c(
                        "label",
                        {
                          staticClass: "field-label",
                          attrs: { for: "contest-entry-new-penname" },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _setup.t(
                                  "contestEntryForm.step1.penname.newLabel"
                                )
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c("span", { staticClass: "field-count" }, [
                        _vm._v(
                          _vm._s(_setup.newPenname.length) +
                            "/" +
                            _vm._s(_setup.pennameMaxLength)
                        ),
                      ]),
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _setup.newPenname,
                          expression: "newPenname",
                        },
                      ],
                      ref: "newPennameInputRef",
                      staticClass: "field-input",
                      attrs: {
                        id: "contest-entry-new-penname",
                        type: "text",
                        maxlength: _setup.pennameMaxLength,
                        placeholder: _setup.t(
                          "contestEntryForm.step1.penname.placeholder"
                        ),
                      },
                      domProps: { value: _setup.newPenname },
                      on: {
                        keydown: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          $event.preventDefault()
                          return _setup.onConfirmAddPenname.apply(
                            null,
                            arguments
                          )
                        },
                        input: function ($event) {
                          if ($event.target.composing) return
                          _setup.newPenname = $event.target.value
                        },
                      },
                    }),
                  ]),
                  _c("footer", { staticClass: "penname-dialog-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "penname-dialog-button primary",
                        attrs: {
                          type: "button",
                          disabled: !_setup.canAddPenname,
                        },
                        on: { click: _setup.onConfirmAddPenname },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _setup.t(
                                "contestEntryForm.step1.penname.addAction"
                              )
                            ) +
                            " "
                        ),
                      ]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "penname-dialog-button",
                        attrs: { type: "button" },
                        on: { click: _setup.closeAddPennameDialog },
                      },
                      [_vm._v(" " + _vm._s(_setup.t("common.cancel")) + " ")]
                    ),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }